import { getURLWithParams } from "utils/context";
import { useFetchMxfNestApi } from "hooks";

export const useAliquotaCbs = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams("aliquota-cbs", params));
